module.exports = __webpack_public_path__ + "img/C03TechLongswordsmanVeteran_ua.4a536fe2.webp";